<template>
  <div id="headerwrap" name="home" ref="headerwrap" :style="mystyle">
    <header class="clearfix container specialheader" :style="myheaderstyle">
      <div class="spLe">
        <h1 v-if="childData.h1">{{$t(childData.h1)}}</h1>
        <h2 v-if="childData.h2">{{$t(childData.h2)}}</h2>
      </div>
      <img class="myimg" v-if="childData.imgurl" :src="childData.imgurl" alt="">
      <b-button
        variant="outline-info"
        class="btn btn-lg"
        v-if="childData.btn"
        to="/solution"
      >{{$t(childData.btn)}}</b-button>
      <!-- <a href="./portfolio.html" >See Our Solution</a> -->
    </header>
  </div>
</template>
<script>
export default {
  props: ["childData"],
  name: "banner",
  data() {
    return {
      timer: null,
      mystyle: "",
      myheaderstyle: ""
    };
  },
  methods: {},
  mounted() {
    this.mystyle = this.childData.style;
    this.myheaderstyle = this.childData.myheaderstyle;
  }
};
</script>

<style>
#headerwrap {
  /* background: url(../../public/img/header_bg.jpg) repeat-x center top; */
  padding-top: 100px;
  text-align: center;
  background-attachment: relative;
  background-position: center center;
  /* min-height: 650px; */
  height: 650px;
  width: 100%;
  -webkit-background-size: 100%;
  -moz-background-size: 100%;
  -o-background-size: 100%;
  background-size: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  padding-bottom: 100px;
  /* margin-top: 60px; */
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: auto 100% !important;
}
.specialheader {
  display: flex;
  justify-content: space-evenly !important;
  align-items: center;
  max-width: 90% !important;
}
.spLe {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 35%;
  justify-content: space-around;
  margin-left: 8%;
}

@media screen and (max-width: 1400px) {
  .specialheader {
    display: flex;
    justify-content: space-evenly !important;
    align-items: center;
    max-width: 100% !important;
  }

  .spLe {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 40%;
    justify-content: space-around;
    margin-left: 5%;
  }
}

@media screen and (max-width: 480px) {
  #headerwrap {
    height: 100%;
    max-height: auto;
  }
  .specialheader {
    display: flex;
    justify-content: space-evenly !important;
    align-items: center;
    max-width: 100% !important;
  }

  .spLe {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
    justify-content: space-around;
  }
}
/* @media screen and (max-width: 1400px) {
  .myimg {
    width: 100%;
  }
  .specialheader {
    display: initial !important;
  }
} */

#headerwrap h1 {
  color: #fff;
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  letter-spacing: 2px;
  padding-bottom: 10px;
}
#headerwrap h2 {
  font-size: 16px;
  color: white;
  line-height: 1.8;
}

#headerwrap .btn {
  font-weight: 500;
  font-size: 17px;
  margin: 20px 0;
  background-color: rgba(255, 255, 255, 0);
  color: #fff;
  border: 1px solid #fff;
}

#headerwrap .btn:hover,
#headerwrap .btn:focus {
  color: #555;
  background-color: #fff;
  outline: 0px;
  border: 1px solid #fff;
}
@media screen and (max-width: 480px) {
  .myimg {
    width: 100%;
  }
  .specialheader {
    display: initial !important;
  }
}
</style>